// Lib
import React from 'react';
import { CSSTransitionGroup } from '../../../../node_module_clones/react-transition-group';

// Utils
import { getHasClones } from '../../../../common/elements/utils/elementPropertyUtils';

// Components
import Icon from '../../../components/icons/Icon';
import ElementTip from '../../suggestion/ElementTip';
import ElementCloneInstancesPopup from './ElementCloneInstancesPopup';
import PopupTrigger from '../../../components/popupPanel/PopupTrigger';

// Types
import { ImMNElement } from '../../../../common/elements/elementModelTypes';

// Styles
import './ElementCloneSection.scss';

const ElementCloneSection = (props: { isClone?: boolean; elementId: string; element: ImMNElement }) => {
    const { isClone, elementId, element } = props;

    const [popupIsOpen, setPopupIsOpen] = React.useState(false);

    const onToggle = React.useCallback((isOpen) => {
        setPopupIsOpen(isOpen);
    }, []);

    const popupId = `card-clone-popup-${elementId}`;

    const contents =
        isClone || getHasClones(element) || popupIsOpen ? (
            <>
                <PopupTrigger popupId={popupId} onToggle={onToggle} preventPropagation>
                    {(isOpen) => <ElementTip className="clone" icon={<Icon name="clone" />} />}
                </PopupTrigger>

                <ElementCloneInstancesPopup popupId={popupId} {...props} />
            </>
        ) : null;

    return (
        <div className="ElementCloneSection">
            <CSSTransitionGroup
                transitionName="slide"
                transitionAppear
                transitionAppearTimeout={3000}
                transitionEnterTimeout={3000}
                transitionLeaveTimeout={3000}
            >
                {contents}
            </CSSTransitionGroup>
        </div>
    );
};

export default ElementCloneSection;
